<template>
  <div class="cs-layout">
    <div v-if="false" class="cs-header py-4 px-5">
      <img class="logo" src="../assets/images/logo.png" />
      <!-- <div class="m-auto text-gray text-3xl font-bold">3D모델 자동분석 견적서</div> -->
    </div>

    <router-view></router-view>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
.logo {
  position: absolute;
  top: calc(100% - 40px);
  transform: translateY(-50%);
  height: 40px;
}
</style>
